import { APP_CONFIG } from 'services/app-config'

export const CONFIG = {
  api: {
    customerSubscriptions: `${APP_CONFIG.apigee_host}/masmovil/v3/customers`,
  },
}
